import styled from 'styled-components'
import staffProfile from '../../assets/images/staffProfile.svg'

const StyledDiv = styled.div`
display: flex;
align-items: center;
`

const StyledRelativeDiv = styled.div`
position: relative;
`

const StyledImage = styled.img`
width: 100px;
height: 100px;
border-radius: 50%;
border: 1px solid lightgray;
box-shadow: 0px 0px 10px lightgray;
`

const StyledDivHover = styled.div`
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: rgba(0,0,0,.5);
width: 100px;
height: 100px;
border-radius: 50%;
display: flex;
color: white;
flex-direction: column;
justify-content: center;
align-items: center;
text-align: center;

@media screen and (min-width: 1100px) {
    display: none;

    ${StyledRelativeDiv}:hover & {
        display: flex;
    }
}
`

const StyledInput = styled.input`
display: none;
`

const StyledFileInput = styled(StyledInput).attrs({
    type: "file"
})``;

export const FileInput = props => {
    return <StyledDiv>
        <label htmlFor={props.inputId}>
            {/* <Button primary>{props.message}</Button> */}
            <StyledRelativeDiv>
                <StyledImage src={props.background ? props.background : staffProfile} alt="profile picture" />
                <StyledDivHover>
                    <i class="fa fa-camera"></i>
                    {props.message}
                </StyledDivHover>
            </StyledRelativeDiv>
            <StyledFileInput {...props} id={props.inputId} />
        </label>
    </StyledDiv>
}